import { render } from "./CorporatePage.vue?vue&type=template&id=24abb638"
import script from "./CorporatePage.vue?vue&type=script&lang=js"
export * from "./CorporatePage.vue?vue&type=script&lang=js"

import "./CorporatePage.vue?vue&type=style&index=0&id=24abb638&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__